<template>
  <div>
    <table-component
      :model="model"
    />
  </div>
</template>

<script>
import TableComponent from '@/dc-it/components/TableComponent.vue'
import Ability from '@/dc-it/models/Ability'

export default {
  name: 'AbilitiesView',
  components: { TableComponent },
  data() {
    return {
      model: Ability,
    }
  },
}
</script>

<style scoped>

</style>
